import React from 'react';
import classNames from 'classnames/bind';
import styles from './Spinner.module.scss';

const cx = classNames.bind(styles);

const LoadingSpinner = ({ grayscaled = false }) => (
  <div className={cx('LoadingSpinner', { is_grayscaled: grayscaled })}>
    {Array.from({ length: 6 }, (_, index) => (
      <i key={index} />
    ))}
  </div>
);

export default LoadingSpinner;
